import React, { useContext } from "react";
var AccordionContext = /*#__PURE__*/React.createContext();
export var AccordionProvider = AccordionContext.Provider;

function useAccordion() {
  var accordionInfo = useContext(AccordionContext);
  return accordionInfo;
}

export default useAccordion;